<template>
    <div class="page-blog">
        <!--banner-->
        <div class="banner">
            <div class="container">
                <h2 class="timeline">“<span>{{keyword}}</span>” 相关的搜索结果</h2>
            </div>
        </div>
        <!--banner-->

        <div class="blog search-page">
            <div class="container" v-if="isShowTip==1">
                <div class="blog-head">
                    <div class="col-md-3 blog-top" v-for="g in gameData" :key="g.path">
                        <div class="blog-in blog-block" v-if="!g.flash">
                            <router-link  :to="'/game/'+g.path" :title="g.title" target="_blank">
                                <img class="img-responsive" :src="imgUrl('static/images/game/'+g.path+'/face')" :alt="g.title">
                            </router-link>
                    <div class='MarkBox search' v-if="g.tuijian === 1">
                      <div class='insideBox tuijian'>推荐</div>
                    </div>
                    <div class='MarkBox search' v-if="g.hot === 1">
                      <div class='insideBox hot'>热门</div>
                    </div>
                    <div class='MarkBox search' v-if="g.biwan === 1">
                      <div class='insideBox biwan'>必玩</div>
                    </div>
                            <div class="blog-grid">
                                <h4><router-link  :to="'/game/'+g.path" :title="g.title" target="_blank">{{g.title}} <span v-if="g.enTitle">（{{g.enTitle}}）</span><span v-if="g.version">v {{g.version}}</span></router-link></h4>
                                <p></p>

                                <div class="date">
                                    <span class="date-in" title="发布日期"><i class="glyphicon glyphicon-calendar"> </i>{{g.date}}</span>
                                    <span class="date-in" title="最后更新日期" v-if="g.update"><i class="glyphicon glyphicon-refresh"> </i>{{g.update}}</span>
                                    <div class="clearfix"> </div>
                                </div>
                                <div class="more-top">
                                    <router-link class="hvr-wobble-top" :to="'/game/'+g.path" :title="g.title" target="_blank">
                                        查看详情
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <!--Flash-->
                        <div class="blog-in" v-if="g.flash">
                            <a :href="'static/flash/'+g.path+'.html'" :title="g.title" target="_blank">
                                <img class="img-responsive" :src="imgUrl('static/images/game/'+g.path+'/face')" :alt="g.title">
                            </a>
                            <div class="blog-grid">
                                <h4><a :href="'static/flash/'+g.path+'.html'" target="_blank">{{g.title}}<span v-if="g.enTitle">（{{g.enTitle}}）</span></a></h4>
                                <p></p>

                                <div class="date">
                                    <span class="date-in"><i class="glyphicon glyphicon-calendar"> </i>{{g.date}}</span>
                                    <div class="clearfix"> </div>
                                </div>
                                <div class="more-top">
                                    <a class=" hvr-wobble-top" :href="'static/flash/'+g.path+'.html'" :title="g.title" target="_blank">查看详情</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"> </div>
                </div>
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[12, 40, 80, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
            <div class="nodata" v-if="isShowTip == 0">
                没有搜到关于 “<span>{{keyword}}</span>” 游戏，您可以前往 “<span>游戏</span>” 菜单按分类筛选游戏
            </div>
        </div>
    </div>
</template>

<script>
import imageExt from '@/mixins/imageExt'

export default {
  name: 'Demo',
  mixins: [imageExt],
  components: {},
  data() {
    return {
      keyword: this.$route.params.id,
      gameList: [],
      resultList: [],
      isShowTip: 0,
      total: 0,
      currentPage: 1, // 默认显示第1页
      pagesize: 12 // 默认一次显示10条数据
    }
  },
  created() {
    this.resultList = []
    this.hasData()
  },
  mounted() {},
  computed: {
    gameData: function() {
      return this.resultList.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
    }
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.keyword = this.$route.params.id
        this.hasData()
      }
    }
  },
  methods: {
    hasData() {
        if(localStorage.getItem('gameList')){
          // 读取本地json
          this.getStaticData()
        } else {
            this.getData()
        }
    },
    getData() {
      this.resultList = []
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/games.json' + '?' + timeStamp).then(game => {
        for (var i = 0; i < game.data.length; i++) {
          if (game.data[i].status === 1) {
            // console.log(game.data[i].title.indexOf(this.keyword))
            if (game.data[i].title.indexOf(this.keyword) > -1 || game.data[i].path.indexOf(this.keyword) > -1 || (game.data[i].author && game.data[i].author.indexOf(this.keyword) > -1) || (game.data[i].enTitle && game.data[i].enTitle.indexOf(this.keyword) > -1)) {
              this.resultList.push(game.data[i])
            }
            // this.gameList.push(game.data[i]);
          }
        }

        this.total = this.resultList.length

        if (this.resultList.length === 0) { // 如果没有匹配结果，就显示提示信息
          this.isShowTip = 0
        } else {
          this.isShowTip = 1
        }
      })
    },
    getStaticData() {
      this.resultList = []
      var gameArr = JSON.parse(localStorage.getItem('gameList'))
        for (var i = 0; i < gameArr.length; i++) {
          if (gameArr[i].status === 1) {
            if (gameArr[i].title.indexOf(this.keyword) > -1 || gameArr[i].path.indexOf(this.keyword) > -1 || (gameArr[i].author && gameArr[i].author.indexOf(this.keyword) > -1) || (gameArr[i].enTitle && gameArr[i].enTitle.indexOf(this.keyword) > -1)) {
              this.resultList.push(gameArr[i])
            }
            // this.gameList.push(game.data[i]);
          }
        }

        this.total = this.resultList.length

        if (this.resultList.length === 0) { // 如果没有匹配结果，就显示提示信息
          this.isShowTip = 0
        } else {
          this.isShowTip = 1
        }
    },
    handleSizeChange(size) {
      this.pagesize = size
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
